var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"menu-icon",attrs:{"to":{ name: 'DashboardProfile' },"title":"Modifier mon profil","tag":"div"}},[_c('div',[_c('img',{attrs:{"src":"/static/images/icons/User.svg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }